import { FC, useEffect, useState } from 'react';
import IframeResizer from 'iframe-resizer-react';
import Iframe from './IFrame';
//import Iframe from 'react-iframe';

type EmbeddedExternalDashboardProps = {
  data: string;
  width?: string;
  height?: string;
};

const EmbeddedExternalDashboard: FC<EmbeddedExternalDashboardProps> = props => {
  const [html, setHtml] = useState<string>('');
  const [script, setScript] = useState<string[]>([]);

  const data = ((props.data as string) || '').trim();

  useEffect(() => {
    if (!!props.data && data.startsWith('<') && data.endsWith('>')) {
      var script: string[] = [];
      var rest = '';

      var src = data;
      var s = src.indexOf('<script');
      while (s !== -1) {
        var e = src.indexOf('</script>');
        script.push(src.slice(s + 8, e));
        src = src.slice(0, s) + src.slice(e + 9);
        s = src.indexOf('<script');
      }
      if (s === -1 && src.length > 0) {
        rest += src;
      }
      setScript(script);
      setHtml(rest);
    }
  }, []);

  useEffect(() => {
    if (!!props.data) {
      script.forEach(s => {
        const scriptEl = document.createElement('script');
        scriptEl.innerHTML = s;
        document.body.append(scriptEl);
      });
    }
  }, [script]);

  if (data.startsWith('<') && data.endsWith('>')) {
    if (!!html)
      return (
        <div
          dangerouslySetInnerHTML={{ __html: html }}
          style={{ width: '80%', height: '80%', display: 'block', position: 'relative' }}
        />
      );
  }

  if (!props.data) return null;

  if (props.width !== undefined) {
    return (
      <Iframe
        url={data}
        width={props.width || '1140px'}
        height={props.height || '700px'}
        display="block"
        position="relative"
      />
    );
  }

  return (
    <IframeResizer
      src={data}
      style={{ minWidth: '100%', minHeight: '90%', display: 'block', position: 'relative' }}
      frameBorder={0}
    />
  );
};

export default EmbeddedExternalDashboard;
